<template>
  <div class="text-center">
    <v-dialog persistent v-if="visible" v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-eye</v-icon> Visualizar Profissional
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form">
            <h2 class="mt-7"><v-icon>mdi-account</v-icon> Dados Pessoais</h2>
            <v-row class="d-flex justify-center align-center mt-2">
              <v-col cols="3">
                <div class="d-flex flex-column pb-5">
                  <v-img :src="imgURL" width="9em" height="9em" class="img"></v-img>
                </div>
              </v-col>
              <v-col cols="9">
                <v-row>
                  <v-col cols="8">
                    <v-text-field
                      :value="content?.nome || ''"
                      label="Nome*"
                      outlined
                      readonly
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      :value="content?.cpf || ''"
                      v-mask="'###.###.###-##'"
                      label="CPF*"
                      outlined
                      readonly
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      :value="content?.email || ''"
                      label="E-mail*"
                      outlined
                      readonly
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      :value="content?.telefone || ''"
                      v-mask="'(##) #####-####'"
                      label="Telefone para Contato*"
                      outlined
                      readonly
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col :cols="content.possuiNomeSocial ? '6' : '12'">
                    <span class="mr-4">Possui nome social?</span>
                    <v-radio-group
                      v-model="content.possuiNomeSocial"
                      class="ml-4"
                      row
                      dense readonly>
                      <v-radio
                        label="Sim"
                        :value="true"
                      ></v-radio>
                      <v-radio
                        label="Não"
                        :value="false"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="6" v-if="content.possuiNomeSocial">
                    <v-text-field
                      v-model="content.nomeSocial"
                      label="Nome Social"
                      outlined
                      dense
                      maxlength="100"
                      counter="100"
                      readonly
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <div v-if="$isUserAdmin()">
              <h2 class="mt-4"><v-icon>mdi-account-check</v-icon> Acesso ao Sistema</h2>
              <v-row class="d-flex justify-center mt-2">
                <v-col cols="12">
                  <v-text-field
                    v-if="content?.perfil?.nome"
                    :value="content.perfil?.nome"
                    label="Perfil de Acesso"
                    outlined
                    readonly
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
            <h2 class="mt-4"><v-icon>mdi-account-tie</v-icon> Dados Profissionais</h2>
            <v-row class="d-flex justify-center mt-2">
              <v-col cols="6">
                <v-text-field
                  :value="content.escolaridade"
                  label="Grau de Escolaridade*"
                  outlined
                  readonly
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-if="content?.perfil?.nome"
                  :value="content?.funcao?.nome"
                  label="Função no Programa*"
                  outlined
                  readonly
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :value="content.municipio"
                  label="Município*"
                  outlined
                  readonly
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :value="content.lotacao"
                  label="Local de Lotação*"
                  outlined
                  readonly
                  dense
                ></v-text-field>
              </v-col>
              <v-col :cols="content.possuiOutroLocalDeLotacao ? '6' : '12'">
                <span class="mr-4">Possui outro local de lotação?</span>
                <v-radio-group
                  v-model="content.possuiOutroLocalDeLotacao"
                  row
                  dense
                  readonly
                  class="ml-4">
                  <v-radio
                    label="Sim"
                    :value="true"
                  ></v-radio>
                  <v-radio
                    label="Não"
                    :value="false"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="6"></v-col>
            </v-row>
            <v-row class="d-flex justify-center mt-2" v-if="content.possuiOutroLocalDeLotacao">
              <v-col cols="6">
                <v-text-field
                  :value="content.municipioLotacaoDois"
                  label="Município"
                  outlined
                  dense
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :value="content.lotacaoDois"
                  label="Local de Lotação"
                  outlined
                  dense
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
            <h2 class="mt-4"><v-icon>mdi-home</v-icon> Endereço Residencial</h2>
            <v-row class="d-flex justify-center mt-2">
              <v-col cols="6">
                <v-text-field
                  :value="content.endereco.cep"
                  v-mask="'#####-###'"
                  label="CEP*"
                  outlined
                  readonly
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :value="content.endereco.logradouro"
                  label="Logradouro*"
                  outlined
                  readonly
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  :value="content.endereco.bairro"
                  label="Bairro*"
                  outlined
                  readonly
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  :value="content.endereco.uf"
                  label="UF*"
                  outlined
                  readonly
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  :value="content.endereco.municipio"
                  label="Município*"
                  outlined
                  readonly
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  :value="content.endereco.numero"
                  label="Número*"
                  outlined
                  readonly
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  :value="content.endereco.complemento"
                  label="Complemento"
                  outlined
                  readonly
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </div>
        <div class="btn-group text-center">
          <v-btn outlined color="primary" @click="$emit('onClose')">
            Fechar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Profissional } from '~/commons/classes/profissional';

export default {
  props: new DialogProps(Profissional),
  computed: {
    imgURL() {
      return this.content.foto ? URL.createObjectURL(this.content.foto) : "/img/picto-icon-user.png";
    }
  }
};
</script>
<style scoped lang="scss">
.img {
  border-radius: 2em;
}
h2 {
  font-size: medium;
}
.btn-image {
  position: absolute;
  left: 8.3%;
  top: 28%;
  z-index: 1;
  &.admin {
    top: 25%;
  }
}
</style>
